import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './WrongModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class WrongModal extends Component {
	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isModalOpen} toggle={this.props.toggleModal}>
		          	<ModalHeader toggle={this.props.toggleModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
		            	{strings.description}
		          	</ModalBody>
		          	<ModalFooter className="justify-content-center">
					  	<button 
		            		type="submit" 
		            		className="showtix-button showtix-background__primary-2"
                            onClick={this.props.checkoutTicket}
						  >{strings.checkout}</button>
		            	<button 
		            		type="submit" 
		            		className="showtix-button showtix-background__primary-3 mt-0"
                            onClick={this.props.toggleModal}
		            		>{strings.ok}</button>
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

WrongModal.propTypes = {
    isModalOpen: PropTypes.bool,
    toggleModal: PropTypes.func
}

export default WrongModal;


// WEBPACK FOOTER //
// ./src/components/Checkin/WrongModal/WrongModal.js